/* eslint-disable */
import { defineStore } from 'pinia';

export const useCcPaymentStore = defineStore('ccpayment', {
	state: () => ({
		deposit_currencies: [],
		withdraw_currencies: [],
		coins: [],
		selected_currency: null,
		currencies_loading: false,
		address_loading: false,
		address: null,
		memo: null,
		coin_info: null,
		exchange_rate_to_usd: null,
		exchange_rate_to_customer: null,
		exchange_loading: false,
		amount: '',
		static_rate: false,
		withdraw_wallet: null,
		freebet_id: null,
		freespin_id: null,
		bonus_id: 0,
		preview_id: null,
	}),
	getters: {
		getCoinPrecision(state) {
			const chain = state.getCoinChain;
			if (state.coin_info && state.coin_info.networks && chain && state.coin_info.networks[chain]) {
				return state.coin_info.networks[chain].precision;
			}
			return 8; // Default precision if not found
		},
		getCoinId(state) {
			if (!state.selected_currency) return null;
			let symbol = state.selected_currency.split('(')[0].trim();
			let coin = state.coins.find(coin =>
				coin.symbol.toUpperCase() === symbol.toUpperCase()
			);

			return coin ? coin.id : null;
		},
		getCoinChain(state) {
			if (!state.selected_currency) return null;
			let chain = state.selected_currency.match(/\(([^)]+)\)/);
			return chain ? chain[1] : null;
		},
		getCurrentExchangeRateToUsd(state) {
			return state.exchange_rate_to_usd;
		},
		getCurrentExchangeRateToCustomer(state) {
			return state.exchange_rate_to_customer;
		},
		getProcessedCoins: (state) => (type) => {

			let currencies;
			if (type == 'deposit') {
				if (state.deposit_currencies.length == 0) return [];
				currencies = state.deposit_currencies;
			} else if (type == 'withdraw') {
				if (state.withdraw_currencies.length == 0) return [];
				currencies = state.withdraw_currencies;
			}

			return Object.entries(currencies).map(([key, order]) => {
				const symbol = key.split('(')[0].trim();
				return {
					full_name: key,
					symbol: symbol,
					order: order || 0
				};
			}).sort((a, b) => {
				// 1. If both have custom order (>0), sort by order ASC
				if (a.order > 0 && b.order > 0) return a.order - b.order;

				// 2. If A has order but B is 0, A comes first
				if (a.order > 0 && b.order === 0) return -1;

				// 3. If B has order but A is 0, B comes first
				if (b.order > 0 && a.order === 0) return 1;

				// 4. If both are 0, sort Alphabetically by full name
				return a.full_name.localeCompare(b.full_name);
			});
		},
		getCoins: (state) => (type) => {
			let coins = state.getProcessedCoins(type).filter(coin =>
				coin.symbol !== 'USDT' && coin.symbol !== 'TRX'
			);

			return coins;
		},
		getUsdtCoins: (state) => (type) => {
			let coins = state.getProcessedCoins(type).filter(coin =>
				coin.symbol === 'USDT'
			);

			return coins;
		},
		getTrxCoins: (state) => (type) => {
			let coins = state.getProcessedCoins(type).filter(coin =>
				coin.symbol === 'TRX'
			);

			return coins;
		},
	},
	actions: {
		fetchCurrencies() {
			this.currencies_loading = true;
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/ccpayment/get_active_coins').then((response) => {

				this.coins = response.data.coins;
				this.currencies_loading = false;

				return Promise.resolve(response.data);
			}).catch((error) => {
				this.currencies_loading = false;
				return Promise.reject(error.response);
			});
		},
		fetchDepositAddress() {
			if (!this.selected_currency) return;

			this.address_loading = true;
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/ccpayment/get_deposit_address', { chain: this.getCoinChain }).then((response) => {
				this.address = response.data.address;
				this.memo = response.data.memo;
				this.address_loading = false;

				return Promise.resolve(response.data);
			}).catch((error) => {
				this.address_loading = false;
				return Promise.reject(error.response);
			});
		},
		fetchExchangeRate() {
			if (!this.selected_currency) return;
			this.exchange_loading = true;
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/ccpayment/exchange_rates', { coinId: this.getCoinId }).then((response) => {
				this.exchange_rate_to_usd = response.data.exchange_rate_to_usd;
				this.exchange_rate_to_customer = response.data.exchange_rate_to_customer;
				this.coin_info = response.data.coin_info;
				this.static_rate = response.data.static_rate;

				this.exchange_loading = false;

				return Promise.resolve(response.data);
			}).catch((error) => {
				this.exchange_loading = false;
				return Promise.reject(error.response);
			});
		},
		resetStore() {
			this.selected_currency = null;
			this.currencies_loading = false;
			this.address_loading = false;
			this.address = null;
			this.memo = null;
			this.coin_info = null;
			this.exchange_rate_to_usd = null;
			this.exchange_rate_to_customer = null;
			this.exchange_loading = false;
			this.amount = '';
			this.static_rate = false;
			this.withdraw_wallet = null;
			this.freebet_id = null;
			this.freespin_id = null;
			this.bonus_id = 0;
			this.preview_id = null;
		},
		resetDepositBonus() {
			this.freebet_id = null;
			this.freespin_id = null;
			this.bonus_id = 0;
			this.preview_id = null;
		},
		selectDepositBonus(bonus) {
			this.bonus_id = 0;

			if (bonus == null) {
				this.freespin_id = null;
				this.freebet_id = null;
				this.preview_id = null; // Also clear preview_id when no bonus is selected
				return;
			}

			// Set preview_id if it exists on the bonus
			this.preview_id = bonus.preview_id || null;

			if (bonus.deposit_bonus_type == 'freebet') {
				this.bonus_id = 0;
				this.freebet_id = bonus.id;
				this.freespin_id = null; // Ensure freespin_id is null if it's a freebet
			} else if (bonus.deposit_bonus_type == 'freespin') {
				this.bonus_id = 0;
				this.freespin_id = bonus.id;
				this.freebet_id = null; // Ensure freebet_id is null if it's a freespin
			} else if (bonus.deposit_bonus_type == 'wagering') {
				this.freebet_id = null; // Ensure freebet_id is null if it's a freespin
				this.freespin_id = null; // Ensure freespin_id is null if it's a freespin
				this.bonus_id = bonus.id;
			}
		},
		selectRegularBonus(bonus) {
			this.freebet_id = null;
			this.freespin_id = null;

			if (bonus) this.bonus_id = bonus.id;
			else this.bonus_id = 0;
		}
	},
})